module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="formLine  index_100_ddksww">\r\n    <div class="form-group col-xs-3 inputField">\r\n        <select id="fieldname" class="form-control">\r\n            <option value="">--</option>\r\n            <option value="itemId" ';
 if(filters.fieldname=="itemId") print("selected='selected'")
__p+=' >Id</option>\r\n            <option value="denominacion" ';
 if(filters.fieldname=="denominacion") print("selected='selected'")
__p+=' >'+
((__t=(lang.DENOMINACION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="epigraph" ';
 if(filters.fieldname=="epigraph") print("selected='selected'")
__p+=' >'+
((__t=(lang.EPIGRAFE))==null?'':_.escape(__t))+
'</option>\r\n            <option value="areaFuncional" ';
 if(filters.fieldname=="areaFuncional") print("selected='selected'")
__p+=' >'+
((__t=(lang.A_FUNCIONAL))==null?'':_.escape(__t))+
'</option>\r\n            <option value="descriptivos_direccion" ';
 if(filters.fieldname=="descriptivos_direccion") print("selected='selected'")
__p+=' >'+
((__t=(lang.DESCRIPTIVOS_DIRECCION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="juridicos_uso" ';
 if(filters.fieldname=="juridicos_uso") print("selected='selected'")
__p+=' >'+
((__t=(lang.USO))==null?'':_.escape(__t))+
'</option>\r\n            <option value="juridicos_costeAdquisicion" ';
 if(filters.fieldname=="juridicos_costeAdquisicion") print("selected='selected'")
__p+=' >'+
((__t=(lang.JURIDICOS_COSTEADQUISICION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="fechaAlta" ';
 if(filters.fieldname=="fechaAlta") print("selected='selected'")
__p+=' >'+
((__t=(lang.FECHA_ALTA))==null?'':_.escape(__t))+
'</option>\r\n            <option value="juridicos_fechaAdquisicion" ';
 if(filters.fieldname=="juridicos_fechaAdquisicion") print("selected='selected'")
__p+=' >'+
((__t=(lang.JURIDICOS_FECHAADQUISICION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="catastrales_referencia" ';
 if(filters.fieldname=="catastrales_referencia") print("selected='selected'")
__p+=' >'+
((__t=(lang.CATASTRALES_REFERENCIA))==null?'':_.escape(__t))+
'</option>\r\n            <option value="registrales_finca" ';
 if(filters.fieldname=="registrales_finca") print("selected='selected'")
__p+=' >'+
((__t=(lang.REGISTRALES_FINCA))==null?'':_.escape(__t))+
'</option>\r\n            <option value="entity" ';
 if(filters.fieldname=="entity") print("selected='selected'")
__p+=' >'+
((__t=(lang.ENTIDAD))==null?'':_.escape(__t))+
'</option>\r\n            <option value="descriptivos_ubicacion" ';
 if(filters.fieldname=="descriptivos_ubicacion") print("selected='selected'")
__p+=' >'+
((__t=(lang.DESCRIPTIVOS_UBICACION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="juridicos_situacionPatrimonial" ';
 if(filters.fieldname=="juridicos_situacionPatrimonial") print("selected='selected'")
__p+=' >'+
((__t=(lang.JURIDICOS_SITUACIONPATRIMONIAL))==null?'':_.escape(__t))+
'</option>\r\n            <option value="juridicos_naturaleza" ';
 if(filters.fieldname=="juridicos_naturaleza") print("selected='selected'")
__p+=' >'+
((__t=(lang.JURIDICOS_NATURALEZA))==null?'':_.escape(__t))+
'</option>\r\n            <option value="descriptivos_importe" ';
 if(filters.fieldname=="descriptivos_importe") print("selected='selected'")
__p+=' >'+
((__t=(lang.ECONOMICOS_VALORTOTAL))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField" id="operatorHolder">\r\n        <select id="nbcomparador" class="form-control operator ';
 if(filters.nbfield!='nbcomparador') print('hidden')
__p+='">\r\n            <option value="=" ';
 if(filters.nbcomparador=="=") print("selected='selected'")
__p+=' >'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n            <option value="<" ';
 if(filters.nbcomparador=="<") print("selected='selected'")
__p+=' >'+
((__t=(lang.MENOR_QUE))==null?'':_.escape(__t))+
'</option>\r\n            <option value=">" ';
 if(filters.nbcomparador==">") print("selected='selected'")
__p+=' >'+
((__t=(lang.MAYOR_QUE))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n        <select id="nbIgual" class="form-control operator ';
 if(filters.nbfield!='nbIgual' && filters.nbfield) print('hidden')
__p+='">\r\n            <option value="=" selected>'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n        <select id="nbIncluye" class="form-control operator ';
 if(filters.nbfield!='nbIncluye') print('hidden')
__p+='">\r\n            <option value="like" selected>'+
((__t=(lang.INCLUYE))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-3 inputField" id="valueHolder">\r\n        <input type="text" id="textValue" class="form-control value ';
 if(filters.valuefield!='textValue' && filters.valuefield) print(' hidden ')
__p+=' " value="';
 if(filters.valuefield=='textValue') print(filters.value)
__p+='" />\r\n        <input type="number" id="numberValue" step="0.001" class="form-control value ';
 if(filters.valuefield!='numberValue') print(' hidden ')
__p+='" value="';
 if(filters.valuefield=='numberValue') print(filters.value)
__p+='" />\r\n        <div id=\'dtpickerBuscar\' class="input-group dateGroup ';
 if(filters.valuefield!='dateValue') print(' hidden ')
__p+='">\r\n            <input type=\'text\' id="dateValue" name="start" class="form-control date value" value="';
 if(filters.valuefield=='dateValue') print(filters.value)
__p+='" />\r\n            <span class="input-group-addon">\r\n                <span class="glyphicon glyphicon-calendar"></span>\r\n            </span>\r\n        </div>\r\n        <select id="epigraphValue" class="form-control value ';
 if(filters.valuefield!='epigraphValue') print(' hidden ')
__p+='">\r\n         ';

            for (var i in params.epigraphs){
                if(filters.valuefield=="epigraphValue" && filters.value==params.epigraphs[i].word){                    
                    print('<option value="'+ params.epigraphs[i].word + '" selected >'+ lang[params.epigraphs[i].word] + '</option>');
                } else {
                    print('<option value="'+ params.epigraphs[i].word + '" >'+ lang[params.epigraphs[i].word] + '</option>');
                }
            }
        
__p+='\r\n        </select>\r\n        <select id="usoValue" class="form-control value ';
 if(filters.valuefield!='usoValue') print(" hidden ")
__p+=' ">\r\n        ';

            for (i in params.uso){
                if(filters.valuefield=="usoValue" && filters.value==params.uso[i].word){
                    print('<option value="'+ params.uso[i].word + '"  selected >'+ lang[params.uso[i].word] + '</option>');
                } else {
                    print('<option value="'+ params.uso[i].word + '"  >'+ lang[params.uso[i].word] + '</option>');
                }
            }
        
__p+='\r\n        </select>\r\n        <select id="areaValue" class="form-control value ';
 if(filters.valuefield!='areaValue') print(" hidden ")
__p+=' ">\r\n        ';

            for (i in params.areas){
                if(filters.valuefield=="areaValue" && filters.value==params.areas[i].word){
                    print('<option value="' + params.areas[i].word + '" selected >'+ lang[params.areas[i].word] + '</option>');
                } else {
                    print('<option value="' + params.areas[i].word + '"  >'+ lang[params.areas[i].word] + '</option>');
                }
            }
        
__p+='\r\n        </select>\r\n	 <select id="situacionValue" class="form-control value ';
 if(filters.valuefield!='situacionValue') print(" hidden ")
__p+=' ">\r\n            ';

                for (i in params.patrimonial){
                    if(filters.valuefield=="situacionValue" && filters.value==params.patrimonial[i].word){
                        print('<option value="' + params.patrimonial[i].word + '" selected >'+ lang[params.patrimonial[i].word] + '</option>');
                    } else {
                        print('<option value="' + params.patrimonial[i].word + '"  >'+ lang[params.patrimonial[i].word] + '</option>');
                    }
                }
            
__p+='\r\n        </select>\r\n	\r\n	\r\n        <select id="naturalezaValue" class="form-control value ';
 if(filters.valuefield!='naturalezaValue') print(" hidden ")
__p+=' ">\r\n            ';

                for (i in params.naturaleza){
                    if(filters.valuefield=="naturalezaValue" && filters.value==params.naturaleza[i].word){
                        print('<option value="' + params.naturaleza[i].word + '" selected >'+ lang[params.naturaleza[i].word] + '</option>');
                    } else {
                        print('<option value="' + params.naturaleza[i].word + '"  >'+ lang[params.naturaleza[i].word] + '</option>');
                    }
                }
            
__p+='\r\n        </select>\r\n\r\n\r\n\r\n        <select id="entidadValue" class="form-control value ';
  if(filters.valuefield!='entidadValue'){  print('hidden') }  
__p+=' ">\r\n           \r\n            ';

            for (i in params.listEntities){
                if(filters.valuefield=="entidadValue" && filters.value==params.listEntities[i].word){
                    print('<option value="' + params.listEntities[i].word + '" selected >'+ lang[params.listEntities[i].word] + '</option>');
                } else {
                    print('<option value="' + params.listEntities[i].word + '"  >'+ lang[params.listEntities[i].word] + '</option>');
                }
            }
        
__p+='\r\n\r\n        \r\n        </select>\r\n\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField">\r\n        <select id="operator" class="form-control">\r\n            <option ';
 if(filters.operator!="and" && filters.operator!="or") print("selected='selected'")
__p+=' >--</option>\r\n            <option value="and" ';
 if(filters.operator=="and") print("selected='selected'")
__p+=' >'+
((__t=(lang.AND))==null?'':_.escape(__t))+
'</option>\r\n            <option value="or" ';
 if(filters.operator=="or") print("selected='selected'")
__p+=' >'+
((__t=(lang.OR))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-2">\r\n        <span class="searchButton add ion ion-ios-plus text-green"></span>\r\n        ';
 if(showremove){ 
__p+='\r\n            <span class="searchButton remove ion-ios-close text-red"></span>\r\n            ';
 } 
__p+='\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/lists/formLine.ejs
// module id = 420
// module chunks = 0